import { ScrollTopCache } from './util';
import { OVERLAY_ACTIVE_CLASS } from './constants';

var ItemSelector = '.MainNavigation__Item--Page';
var OverlaySelector = '.Overlay';

// Scroll top position cache for overlay navigation
let scrollTopCache = new ScrollTopCache();

$('.MainNavigation__Item--Language > a').on('click', function (e) {
  e.preventDefault();
  $('.Overlay--MainNavigation').removeClass(OVERLAY_ACTIVE_CLASS);
  $(this).parent().toggleClass('active');
});

$('.MainNavigation__Item--Quick > a').on('click', function (e) {
  e.preventDefault();
  $('.Overlay--MainNavigation').removeClass(OVERLAY_ACTIVE_CLASS);
  $(this).parent().toggleClass('active');
});

$('.MainNavigation__Item--Page > a').on('click', function (e) {
  const $this = $(this);

  e.preventDefault();

  scrollTopCache.update();
  $('html').addClass(OVERLAY_ACTIVE_CLASS);
  $('.MainNavigation__Item--Language').removeClass('active');
  $('.MainNavigation__Item--Quick').removeClass('active');
  $('.Overlay--MainNavigation').removeClass(OVERLAY_ACTIVE_CLASS);
  $this.parent().children(OverlaySelector).addClass(OVERLAY_ACTIVE_CLASS);
});

$('.Overlay--MainNavigation .Overlay__Link--Previous').on(
  'click',
  function (e) {
    const $this = $(this);
    const $navItem = $this.parents(ItemSelector);

    e.preventDefault();

    $this.parents(OverlaySelector).removeClass(OVERLAY_ACTIVE_CLASS);

    let $prev = $navItem.prev().find(OverlaySelector);

    if ($prev.length <= 0) {
      $prev = $navItem
        .parent()
        .children(ItemSelector)
        .last()
        .find(OverlaySelector);
    }

    $prev.addClass(OVERLAY_ACTIVE_CLASS);
  }
);

$('.Overlay--MainNavigation .Overlay__Link--Next').on('click', function (e) {
  const $this = $(this);
  const $navItem = $this.parents(ItemSelector);

  e.preventDefault();

  $this.parents(OverlaySelector).removeClass(OVERLAY_ACTIVE_CLASS);

  $navItem.next().find(OverlaySelector).addClass(OVERLAY_ACTIVE_CLASS);

  let $next = $navItem.next().find(OverlaySelector);

  if ($next.length <= 0) {
    $next = $navItem
      .parent()
      .children(ItemSelector)
      .first()
      .find(OverlaySelector);
  }
  $next.addClass(OVERLAY_ACTIVE_CLASS);
});

$('.Overlay__Link--Close').on('click', function (e) {
  const $this = $(this);

  e.preventDefault();

  $('.Overlay--MainNavigation').removeClass(OVERLAY_ACTIVE_CLASS);
  $('html').removeClass(OVERLAY_ACTIVE_CLASS);
  scrollTopCache.apply();
});
